/* eslint-disable prefer-destructuring */
import { pr } from '@/utils/pxToRem';
import { Stack, Link, Grid } from '@mui/material';
import {
  FC, useEffect, useMemo, useRef, useState,
} from 'react';
import AIRPORT_VN from '@/mappings/airport_vn.json';
import { genLinkSeo, genLinkSeoForVexPage } from '@/utils/genLinkSeo';
import { isEmpty } from 'lodash';
import { styled } from '@mui/system';
import { Airlines_Code, Airlines_Name } from './CompanyToRouteVcms';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { style } from '@/styles/globals';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { templateStr } from '@/utils/templateStr';
import { removeVietnameseTones } from '@/utils/stringConvert';

interface SectionFamousRouteProps {
  startPoint?: any;
  toPoint?: any;
  airlineSlug?: any;
  showToOnly?: any;
  airport?: any;
  isDesktop?: any;
  block?: any;
  lang?: ILangObj;
  title?: string;
}
const TitleContent = styled('h3')`
  vertical-align: bottom;
  color: ${style.primary.black} !important;
`;

const PopularRoutesAirlineFromToCityVcms: FC<SectionFamousRouteProps> = ({
  startPoint, toPoint, airlineSlug, showToOnly, isDesktop, airport, block, lang, title,
}) => {
  const airlineCode = Object.keys(Airlines_Code).find((code: any) => Airlines_Code[code] === airlineSlug) || '';
  const airlineName = airlineCode ? ` ${Airlines_Name[airlineCode]} ` : '';

  const fromText = (cityName?: string) => (lang?.lang === 'en' ? templateStr(lang?.PopularRotes?.fromText, {
    airlineName,
    fromLocation: removeVietnameseTones(startPoint.location),
    toLocation: removeVietnameseTones(cityName || ''),
  }) : ` Vé máy bay${airlineName} giá rẻ từ ${startPoint.location} đi ${cityName}`);

  const toText = (cityName?: string) => (lang?.lang === 'en' ? templateStr(lang?.PopularRotes?.toText, {
    airlineName,
    fromLocation: removeVietnameseTones(cityName || ''),
    toLocation: removeVietnameseTones(toPoint.location),
  }) : ` Vé máy bay${airlineName} giá rẻ từ ${cityName} đi ${toPoint.location}`);
  const toOnlyText = (cityName?: string) => (lang?.lang === 'en' ? templateStr(lang?.PopularRotes?.toOnlyText, {
    airlineName,
    toLocation: removeVietnameseTones(cityName || ''),
  }) : ` Vé máy bay${airlineName} giá rẻ từ ${cityName} đi ${toPoint.location}`);
  const key = (startPoint || toPoint)?.airports[0]?.airportCode;
  const listRoute = (AIRPORT_VN as any).routes[key];
  if (listRoute?.length > 10) {
    listRoute.length = 10;
  }
  const [list1, list2] = useMemo(() => {
    const copyListRoute = JSON.parse(JSON.stringify(listRoute || []));
    const tempList1 = copyListRoute.splice(0, 5);
    return [tempList1, copyListRoute];
  }, [listRoute, startPoint, toPoint]);
  if (isEmpty(listRoute)) {
    return null;
  }
  const seoPageAffix = '/vcms/vex/vn';
  const fromLinkSeo = (areaData: any) => ({
    startName: startPoint?.location,
    startId: startPoint?.id,
    startStateName: startPoint?.stateName,
    endName: areaData?.CityName_Vi,
    endId: +(areaData?.VxrAreaParentId || 0),
    endStateName: areaData?.stateName,
    company: airlineSlug || '',
    seoPageAffix,
    lang,
  });
  const toLinkSeo = (areaData: any) => ({
    startName: areaData?.CityName_Vi,
    startId: +(areaData?.VxrAreaParentId || 0),
    startStateName: areaData?.stateName,
    endName: toPoint?.location,
    endId: toPoint?.id,
    endStateName: toPoint?.stateName,
    company: airlineSlug || '',
    seoPageAffix,
    lang,
  });
  const toOnlyLinkSeo = (areaData: any) => ({
    endName: areaData?.CityName_Vi,
    endId: +(areaData?.VxrAreaParentId || 0),
    endStateName: areaData?.stateName,
    company: airlineSlug || '',
    seoPageAffix,
    lang,
  });
  return (
    isDesktop ? (
      <>
        <TitleContent>{title || block?.headingContent?.title}</TitleContent>
        <Grid
          container
          marginTop={pr`16px`}
        >
          {[list1, list2].map((list, idx) => (
            <Grid
              key={idx}
              item
              xs={12}
              md={6}
            >
              <Stack spacing="16px">
                {list?.map((airportCode: string) => {
                  const areaData = AIRPORT_VN.airports.find(
                    (item) => item.AirportCode === airportCode,
                  );
                  return (
                    <Link
                      sx={{
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '20px',
                        textDecoration: 'none',
                        color: `${style.primary.blue}`,
                        textDecorationLine: 'underline',
                        textDecorationColor: `${style.primary.blue}`,
                      }}
                      href={genLinkSeoForVexPage(startPoint ? fromLinkSeo(areaData) : (showToOnly ? toOnlyLinkSeo(areaData) : toLinkSeo(areaData)))}
                      key={airportCode}
                    >
                      {startPoint ? fromText(areaData?.CityName_Vi) : (showToOnly ? toOnlyText(areaData?.CityName_Vi) : toText(areaData?.CityName_Vi))}
                    </Link>
                  );
                })}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </>
    )
      : (
        <>
          <TitleContent>{title || block?.headingContent?.title}</TitleContent>
          <Stack
            spacing="16px"
            marginTop={pr`16px`}
          >
            {listRoute?.map((airpotCode: string) => {
              const areaData = AIRPORT_VN.airports.find((item) => item.AirportCode === airpotCode);
              return (
                <Link
                  sx={{
                    fontWeight: 400,
                    fontSize: '14px',
                    lineHeight: '20px',
                    textDecorationLine: 'underline',
                    color: `${style.primary.blue}`,
                    textDecorationColor: `${style.primary.blue}`,
                  }}
                  href={genLinkSeoForVexPage(startPoint ? fromLinkSeo(areaData) : (showToOnly ? toOnlyLinkSeo(areaData) : toLinkSeo(areaData)))}
                  key={airpotCode}
                >
                  {startPoint ? fromText(areaData?.CityName_Vi) : (showToOnly ? toOnlyText(areaData?.CityName_Vi) : toText(areaData?.CityName_Vi))}
                </Link>
              );
            })}
          </Stack>
        </>
      )
  );
};

export default PopularRoutesAirlineFromToCityVcms;
